import hat from 'hat';

function randomPassword() {
  return hat().substring(0, 12);
}

export default randomPassword;
